const SET_STATE = 'contactInfoReducer/SET_STATE'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setContactInfoState = (stateValues) => ({
  type: SET_STATE,
  payload: stateValues,
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const contactInfoReducer = (state, action) => {
  if (action.type === SET_STATE) {
    return {
      ...state,
      ...action.payload,
    }
  }

  return state
}
